<template>
  <div class="flex min-h-screen items-center justify-center bg-gray-50">
    <div class="w-full max-w-sm rounded-xl bg-white p-10 text-center shadow-md">
      <h1 class="text-2xl font-bold text-gray-900">Clafoutis</h1>
      <p class="mt-2 mb-8 text-sm text-gray-500">
        Connectez-vous avec votre compte Google professionnel.
      </p>
      <div class="flex justify-center">
        <div ref="googleButton"></div>
      </div>
      <p v-if="error" class="mt-4 text-sm text-red-600">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import {isAuthenticated, loginWithGoogleCredential} from "@/auth";

export default {
  name: "LoginView",
  data() {
    return {
      error: null,
    };
  },
  mounted() {
    if (isAuthenticated()) {
      window.location.href = this.redirectTarget();
      return;
    }
    this.loadGoogleScript().then(() => this.renderButton());
  },
  methods: {
    redirectTarget() {
      return this.$route.query.redirect || "/";
    },
    loadGoogleScript() {
      if (window.google && window.google.accounts) {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    renderButton() {
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: this.onCredential,
        auto_select: true,
        hd: "onetsolutions.net",
      });
      window.google.accounts.id.renderButton(this.$refs.googleButton, {
        type: "standard",
        size: "large",
        text: "signin_with",
        shape: "rectangular",
      });
      window.google.accounts.id.prompt();
    },
    async onCredential(response) {
      this.error = null;
      try {
        await loginWithGoogleCredential(response.credential);
        window.location.href = this.redirectTarget();
      } catch (e) {
        const message =
            e.response && e.response.data && e.response.data.message
                ? e.response.data.message
                : "Connexion refusée.";
        this.error = message;
      }
    },
  },
};
</script>
